export const formatAmount = (amount: number, useGrouping?: boolean): string => {
  return Intl.NumberFormat('ru-RU', {
    useGrouping: useGrouping ?? true,
  }).format(amount);
};

export const cleanFormatNumber = (value: string): string =>
  value.replace(/[^\d]+/g, '');
